<script lang="ts">
    import ChevronRight from '@amp/web-app-components/assets/icons/chevron-right-bold.svg';
    import ChevronLeft from '@amp/web-app-components/assets/icons/chevron-left-bold.svg';
    import { createEventDispatcher } from 'svelte';
    import type { MarqueeDirection } from './types';

    const dispatch = createEventDispatcher();

    function handleMouseLeave() {
        dispatch('mouseLeavePaddle');
    }

    function handleOnClick(direction: MarqueeDirection) {
        dispatch('paddleClick', { direction });
    }
</script>

<div class="paddle-controls-container" data-testid="paddle-controls-container">
    <!-- TODO: rdar://148101387 (Classical on Web: Add Aria Label LOC for Right & Left Paddle Controls in LCD) -->
    <button
        type="button"
        class="paddle-left"
        aria-label="scroll marquee forward"
        data-testid="paddle-left"
        on:mouseleave={handleMouseLeave}
        on:click|self={() => handleOnClick('normal')}
    >
        <ChevronLeft aria-hidden="true" />
    </button>
    <button
        type="button"
        class="paddle-right"
        aria-label="scroll marquee in reverse"
        data-testid="paddle-right"
        on:mouseleave={handleMouseLeave}
        on:click|self={() => handleOnClick('reverse')}
    >
        <ChevronRight aria-hidden="true" />
    </button>
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/sasskit-stylekit/ac-sasskit-config';
    @use 'ac-sasskit/core/locale' as *;
    @use 'amp/stylekit/core/mixins/overflow-bleed' as *;
    @use '@amp/web-shared-styles/app/core/globalvars' as *;
    @use '@amp/web-shared-styles/app/core/mixins/focus' as *;

    .paddle-controls-container {
        position: absolute;
        inset: 0;
        display: grid;
        grid-template-columns: auto 1fr auto;
        grid-template-areas: 'paddle-left . paddle-right';
        align-items: center;
        opacity: var(--paddle-controls-opacity, 0);
        padding-inline-start: var(
            --paddle-controls-offset-inline-start,
            $marquee-inline-spacing
        );
        padding-inline-end: var(
            --paddle-controls-offset-inline-end,
            $marquee-inline-spacing
        );
        pointer-events: none; // Forward non-button events to LCD links underneath paddle container

        // reveal paddle controls when using keyboard navigation
        &:has(:focus-visible) {
            --paddle-controls-opacity: 1;
        }
    }

    .paddle-left,
    .paddle-right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        pointer-events: all; // Ensure that paddle buttons are clickable

        &:focus-visible {
            @include focus-shadow-inset;
        }

        :global(svg) {
            fill: var(--systemSecondary);
            overflow: visible;
            width: 10px;
            height: 10px;

            @include rtl {
                transform: scaleX(-1);
            }
        }
    }

    .paddle-left {
        grid-area: paddle-left;
    }

    .paddle-right {
        grid-area: paddle-right;

        @include overflow-bleed-bottom(3px);
    }
</style>
